import Vue from 'vue'

export default function toast() {
	return {
		error(text, title = '😕 Ocurrió un error'){
			Vue.prototype.$notification.open({
				message: title,
				description: text,
				key: (Math.random() * 99999),
				style: {
					'background-color': 'var(--danger)',
					'color': 'white !important'
				},
			})
		},
		warning(text, title = '📢 Alerta') {
			Vue.prototype.$notification.open({
				message: title,
				description: text,
				key: (Math.random() * 99999),
				style: {
					'background-color': 'var(--warning)',
					'color': 'white !important'
				},
			})
		},
		success(text, title = '😄 Operación realizada') {
			Vue.prototype.$notification.open({
				message: title,
				description: text,
				key: (Math.random() * 99999),
				style: {
					'background-color': 'var(--success)',
					'color': 'white !important'
				},
			})
		},
		info(text, title = '🔔 Información') {
			Vue.prototype.$notification.open({
				message: title,
				description: text,
				key: (Math.random() * 99999),
				style: {
					'background-color': 'var(--info)',
					'color': 'white !important'
				},
			})
		},
		_400(params){
			// import { createElement } from "@vue/composition-api";
			// const h = createElement;


			const key = (Math.random() * 99999);
			Vue.prototype.$notification.open({
				message: '😕 Ocurrió un error',
				description: 'No se han recibido los parámetros correctos',
				duration: 100000,
				btn: (h) => h(
					'a-button',
					{
						props: {
							type: 'dashed',
							size: 'small',
							footer: null
						},
						on: {
							click: () => {
								Vue.prototype.$notification.close(key);

								let errs = []
								if (Array.isArray(params.errors)){
									errs = params.errors.map((e) => h('div', {
										style: {
											'margin-left': '-30px',
											'margin-bottom': '5px'
										}
									}, [
											h('fa-icon', { props: { icon: ['fas', 'times'] }, style: { color: Vue.prototype.$colors.danger, 'font-size': '16px' }, class: 'mr-2' }),
										h('span', e)
									]));
								}

								Vue.prototype.$info({
									title: h('h4', ['🦠 ERRORES', h('a-badge', { props: { count: errs.length, offset: [10, -5] } })]),
									icon: '',
									iconType: '',
									okText: 'Cerrar',
									okType: 'danger',
									width: '700px',
									content: errs
								});
							}
						},
						style: {
							'background-color': 'black',
							'border-color': 'black !important',
							color: 'white !important'
						}
					},
					'🐛 Ver Errores'
				),
				key,
				style: {
					'background-color': 'var(--danger)',
					color: 'white !important'
				}
			});
		}
	}
};
